import React, { Component } from 'react'
import { Row, Switch } from 'antd'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import ApprovalList from '../../../../components/Main/Dashboard/Approvals/ApprovalList'
import { PostCard } from '../../../../components/Main/Dashboard/WallTimeLine'
import Authentication from '../../../../modules/Authentication'

const auth = new Authentication()

class Approvals extends Component {
  render() {
    const { list, visibleClaim, claim, onChangeSwitch, fetch } = this.props
    return (
      <div
        style={{
          padding: '10px',
          width: '100%',
          display: list.length <= 0 && 'none',
        }}>
        <PostCard
          extra={<RefreshButton onClick={fetch} />}
          title={
            <Row>
              <Row>
                <h3>Pending Approvals</h3>
              </Row>
              <Row>
                <Switch
                  style={{ marginLeft: 10, marginBottom: 10 }}
                  checkedChildren="direct"
                  unCheckedChildren="All"
                  onChange={onChangeSwitch}
                  defaultChecked
                />
              </Row>
            </Row>
          }
          bordered={false}>
          <ApprovalList {...this.props} />
        </PostCard>
      </div>
    )
  }
}

Approvals.propTypes = {}
Approvals.defaultProps = {}

export default Approvals
